import store from '@/store';

export function isAborted(requestId) {
    return store.getters['requests/aborted'](requestId);
}

export default isAborted;
